import { Subject } from 'rxjs'

import { MapPosition } from '@/domain/protocols/MapPosition'

const MapClickEvent = new Subject<MapPosition>()
const MapClickEventFromMeasuringSegment = new Subject<MapPosition>()
const MapMouseMoveEvent = new Subject<MapPosition>()
// Asks the map to frame an active user geometry (by id) — "Mostrar no mapa" in My Content.
// The geometry's bounds are only known on the map side, once its render data is loaded.
const UserGeometryFocusRequestEvent = new Subject<string>()

export { MapClickEvent, MapClickEventFromMeasuringSegment, MapMouseMoveEvent, UserGeometryFocusRequestEvent }
